import { StyleSheet, Platform } from 'react-native';
import Colors from '../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: 10,
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
    borderRadius: 10,
    // overflow: 'hidden',
  },
  iconContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height:'100%',
    borderRadius: 10,
  },
  removeContainer: {
    position: 'absolute',
    // top: -1.5,
    // right: -1.5,
    top: 3,
    right: 3,
    // borderTopRightRadius: 10,
  },
  removeIcon2: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  notAccepted: {
    position: 'absolute',
    top: 3,
    left: 3,
  },
  notAcceptedIcon: {
    position: 'absolute',
  },
  // captionOverlay: {
  //   // position:'absolute',
  //   // left:0,
  //   // bottom: 0,
  //   width:'100%',
  //   maxHeight: '100%',
  //   padding:10,
  //   backgroundColor: 'rgba(0,0,0,0.55)',
  //   borderRadius: 10,
  //   overflow: 'auto',
  // }
  captionOverlay: {
    position:'absolute',
    left:0,
    bottom: 0,
    width: '100%',
    padding: 8,
    backgroundColor: 'rgba(0,0,0,0.65)',
    borderRadius: 10,
    overflow: 'auto',
    ...Platform.select({
      native: {
        maxHeight: 46,
      },
      web: {
        maxHeight: '70%',
      }
    })
  },
});

export default styles;